// This mixin introduces a percentage filter

// @vue/component
export default {
  filters: {
    percentage: value => `${value} %`
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/dashboard/widgets/widgets/mixins/WidgetPercentageMixin.js